/* src/app/shared/components/paperless-commercial-invoice/components/paperless-commercial-invoice-settings-dialog/paperless-commercial-invoice-settings-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.enrollment-message {
  margin: 2rem 0 1rem;
  font-weight: 700;
  font-size: 1.1em;
}
.enrollment-note {
  margin-bottom: 2rem;
  font-size: 0.9em;
}
.divider {
  width: 100%;
  border-bottom: solid thin #cecccc;
  margin-bottom: 2rem;
}
.upload {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  padding: 1.5rem;
}
@media screen and (min-width: 48rem) {
  .upload {
    flex-direction: row;
  }
}
.upload .actions {
  display: block;
  flex-direction: row;
  justify-content: space-between;
  order: 2;
  min-width: 226px;
  padding: 0.5rem 0rem 0 0;
}
@media screen and (min-width: 48rem) {
  .upload .actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    order: 1;
    align-items: center;
    padding: 0.5rem 1.5rem 0 0;
  }
}
.upload .actions label input[type=file] {
  height: 0;
  margin-left: -9999px;
}
.upload .actions .upload-btn {
  background: #004791;
}
.upload .actions .mat-mdc-raised-button {
  color: #BFB8AF;
}
.upload .preview {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  order: 1;
  flex: 1;
}
@media screen and (min-width: 48rem) {
  .upload .preview {
    order: 2;
  }
}
.upload .preview .image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: solid thin #cecccc;
  width: 100%;
  height: 65px;
}
.upload .preview .image-restrictions {
  font-size: 0.75em;
  margin: 0.5em auto;
  color: #817b7b;
}
.upload.letterhead .image-container img {
  width: 100%;
  height: 50px;
}
@media screen and (min-width: 48rem) {
  .upload.letterhead .image-container img {
    width: 250px;
  }
}
.upload.signature .image-container img {
  width: 100%;
  height: 40px;
}
@media screen and (min-width: 48rem) {
  .upload.signature .image-container img {
    width: 250px;
  }
}
.upload-note {
  font-size: 0.8em;
  padding: 0 1.5rem;
  margin-bottom: 1.5rem;
}
.mat-mdc-dialog-actions {
  padding: 2.5rem;
  margin-bottom: 0;
  font-size: 0.8em;
}
.mat-mdc-dialog-actions a {
  padding: 0 1em;
  text-decoration: none;
  line-height: 1;
}
.mat-mdc-dialog-actions a.cancel {
  color: #817b7b;
}
.mat-mdc-dialog-actions a:not(:last-of-type) {
  border-right: solid thin #817b7b;
}
.error-message {
  color: #DF2901;
  font-size: 0.8em;
  text-align: center;
}
.mat-dialog-actions {
  display: flex;
  margin-left: 44px;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
}
.mat-dialog-actions .action-btns {
  border-radius: 3px;
  padding: 6px 15px;
  border-radius: 3px;
  height: 36px;
}
.mat-dialog-actions .cancel {
  border: 1px solid #004791;
  background: white;
  color: #004791;
}
.mat-dialog-actions .cancel:hover {
  background: #F2F1EF;
}
.mat-dialog-actions .submit-btn {
  margin-left: 20px;
}
mat-dialog-content.mat-mdc-dialog-content.mdc-dialog__content {
  padding-bottom: 0;
}
upsc-file-selector {
  width: 100%;
}
/*# sourceMappingURL=paperless-commercial-invoice-settings-dialog.component.css.map */
